import { MatDateFormats } from "@angular/material/core";

/** Marker used by TreesloNativeDateAdapter for grid-aligned input display. */
export const TREESLO_MEDIUM_DATE_DISPLAY = {
  treesloMediumDate: true,
} as const;

export function buildMaterialDateFormats(_lang: string): MatDateFormats {
  return {
    parse: {
      dateInput: null,
    },
    display: {
      dateInput: TREESLO_MEDIUM_DATE_DISPLAY,
      monthLabel: { month: "long" },
      monthYearLabel: { month: "long", year: "numeric" },
      dateA11yLabel: { year: "numeric", month: "long", day: "numeric" },
      monthYearA11yLabel: { year: "numeric", month: "long" },
    },
  };
}

export function isTreesloMediumDateDisplay(displayFormat: unknown): boolean {
  return (
    typeof displayFormat === "object" &&
    displayFormat !== null &&
    "treesloMediumDate" in displayFormat
  );
}
